import { useTranslation } from 'react-i18next';
import { UserGroupsAdmin } from '../components/UserGroupsAdmin';

/**
 * Eigenstaendige Seite fuer Gruppen-Manager (Rolle `user`). Admins verwalten Benutzergruppen
 * weiterhin innerhalb der Benutzerverwaltung; diese Route gibt Managern denselben Bereich,
 * serverseitig auf ihre eigenen Gruppen beschraenkt.
 */
export default function UserGroupsPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-3xl px-6 py-10">
      <h1 className="text-2xl font-bold tracking-tight">{t('userGroups.title')}</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{t('userGroups.managerSubtitle')}</p>
      <UserGroupsAdmin />
    </div>
  );
}
